export * from './DetailsViewSection';
import DetailsViewSection from './DetailsViewSection';
export default DetailsViewSection;
